export default __webpack_public_path__ + "static/media/330_dummy2016-raumgestalter01-mobile-de.d49e3dfa.png";